import {
    UilBalanceScale,
    UilHistory,
    UilUsersAlt,
} from '@iconscout/react-unicons';
import VsimavecHead from '../../assets/vsimavec-head.svg';
import { Button } from '../buttons/Button';

interface PlanIntroStepProps {
    onStart: () => void;
    onBack: () => void;
}

// Zadání dotazníku od psychologů — instrukce rozhodují o kvalitě odpovědí,
// proto je učitel dostane dřív, než uvidí první otázku. Nadpis nese samotný
// pokyn, tělo jen upřesnění: kdo spěchá, přečte tři tučné řádky a odnese si vše.
const INSTRUCTIONS: {
    title: string;
    text: string;
    icon: typeof UilHistory;
}[] = [
    {
        title: 'Vybavte si posledních 14 dní až měsíc',
        text: 'Odpovědi vztahujte k situacím za nedávné období.',
        icon: UilHistory,
    },
    {
        title: 'Berte třídu jako celek',
        text: 'Hodnoťte ji napříč různými hodinami, situacemi i jednotlivými žáky.',
        icon: UilUsersAlt,
    },
    {
        title: 'Neutrální odpověď volte výjimečně',
        text: 'Možnost „Nejsem si jistý/á" volte jen v případech, kdy se podle vašeho úsudku nelze přiklonit k souhlasu ani nesouhlasu.',
        icon: UilBalanceScale,
    },
];

export function PlanIntroStep({ onStart, onBack }: PlanIntroStepProps) {
    return (
        <div className="mx-auto flex w-full max-w-2xl flex-col items-center text-center">
            <div className="mb-8 w-20">
                <img
                    src={VsimavecHead}
                    alt="Všímavec"
                    className="h-full w-full object-contain"
                />
            </div>
            <h1 className="text-5xl">Vítejte v plánu na míru</h1>
            <p className="mt-3 text-ink-800">
                Společně zmapujeme, jak si vy a vaše třída vedete v různých
                oblastech.
            </p>
            <p className="mt-2 text-ink-800">
                Výsledky vám pomohou vytvořit plán cvičení na míru a ukáží, kde
                vám Všímavec může být největší podporou a parťákem.
            </p>
            <p className="mt-2 text-ink-800">
                Dotazník budete moci po čase opakovat a sledovat, v čem se třída
                posunula a na co se dále zaměřit.
            </p>

            <div className="mt-10 w-full rounded-2xl bg-white p-6 text-left shadow-sm">
                <h5 className="mb-4">Jak při vyplňování postupovat</h5>
                <ul className="divide-y divide-cloud-200">
                    {INSTRUCTIONS.map((item) => (
                        <li
                            key={item.title}
                            className="flex gap-4 py-4 first:pt-0 last:pb-0"
                        >
                            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-product-100 text-product-500">
                                <item.icon size={22} />
                            </div>
                            <div>
                                <p className="font-semibold text-ink-900">
                                    {item.title}
                                </p>
                                <p className="mt-0.5 text-sm text-ink-800">
                                    {item.text}
                                </p>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>

            <div className="mt-10 flex w-full max-w-sm flex-col">
                <Button color="product" className="text-base" onClick={onStart}>
                    Spustit dotazník
                </Button>
                <button
                    type="button"
                    onClick={onBack}
                    className="mt-4 text-sm text-ink-700 underline"
                >
                    Zpět na volbu ročníku
                </button>
            </div>
        </div>
    );
}
